module.exports = __webpack_public_path__ + "static/media/substitution_out.842e488e.svg";